// extracted by mini-css-extract-plugin
export default {"controlButton":"VideoPlayer_controlButton__zizdB","controlButtonGrey":"VideoPlayer_controlButtonGrey__n3aJk"};